import { render, staticRenderFns } from "./CatalogItem.vue?vue&type=template&id=7bf52309&"
import script from "./CatalogItem.vue?vue&type=script&lang=js&"
export * from "./CatalogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports